export default __webpack_public_path__ + "static/media/logo.a532a49e.png";